import React, { useEffect, useState } from "react";
import { Form, Table } from "react-bootstrap";
import { DayAndHourForm } from "./DayAndHourForm";
import { Days } from "../../../../../../_helpers/Helpers";

export function TimetableEditForm({
  editTable,
  courses,
  sections,
  teachers,
  courseHours,
  dayAndHourData,
  btnRef,
  saveTimetable
}) {
  const [dayAndHourDataValues, setDayAndHourDataValues] = useState([]);

  useEffect(() => {
    setDayAndHourDataValues(dayAndHourData);
  }, [dayAndHourData]);

  return (
    <Form onSubmit={e => {
      e.preventDefault();
      saveTimetable(dayAndHourDataValues);
    }}>
      <Table responsive striped bordered hover>
        <thead>
          <tr>
            <th className="text-center" style={{width: "8%"}}>Haftaiçi</th>
            {
              Days.map((day, i) => <th key={i} className="text-center" style={{width: "12%"}}>{day}</th>)
            }
            <th className="text-center" style={{width: "8%"}}>Haftasonu</th>
          </tr>
        </thead>
        <tbody>
          {
            courseHours.map(hour =>
              <tr key={hour.courseHour} style={{backgroundColor: hour.courseHour %2 !== 1 ? "#45dde0" : "#80f709"}}>
                <th className="text-center align-middle">
                  {hour.courseHour}. Ders
                  <br />
                  {hour.weekdayStartHour} 
                  <br />
                  {hour.weekdayEndHour}
                </th>

                {
                  Days.map((day, i) =>
                    <DayAndHourForm
                      key={i}
                      index={i}
                      hour={hour.courseHour}
                      courses={courses}
                      sections={sections}
                      teachers={teachers}
                      editTable={editTable}
                      dayAndHourData={dayAndHourData}
                      values={dayAndHourDataValues}
                      setDayAndHourDataValues={setDayAndHourDataValues}
                    />
                  )
                }

                <th className="text-center align-middle">
                  {hour.courseHour}. Ders
                  <br />
                  {hour.weekendStartHour} 
                  <br />
                  {hour.weekendEndHour}
                </th>
              </tr>
            )
          }
        </tbody>
      </Table>

      <button
        type="submit"
        style={{ display: "none" }}
        ref={btnRef}
      ></button>
    </Form>
  );
}